import { AddedFleetEntry, ResolvedFleetEntry } from "../../../api/fleet"

export type Status = `adding` | `validated` | `serverResolved` | `confirmed`

export type AddToFleetState = {
  validFleetEntries: ReadonlyArray<AddedFleetEntry>
  unresolvedFleetEntries: ReadonlyArray<AddedFleetEntry>
  resolvedFleetEntries: ReadonlyArray<ResolvedFleetEntry>
  manuallyResolvedFleetEntries: ReadonlyArray<ResolvedFleetEntry>
  status: Status
  vehicleSetId: string
}

export const addToFleetInitialState: AddToFleetState = {
  validFleetEntries: [],
  resolvedFleetEntries: [],
  unresolvedFleetEntries: [],
  manuallyResolvedFleetEntries: [],
  status: `adding`,
  vehicleSetId: ``,
}

export type AddToFleetAction =
  | { type: "setValidFleetEntries"; entries: ReadonlyArray<AddedFleetEntry> }
  | {
      type: "setResolvedAndUnresolvedFleetEntries"
      resolved: ReadonlyArray<ResolvedFleetEntry>
      unresolved: ReadonlyArray<AddedFleetEntry>
      vehicleSetId: string
    }
  | { type: "entriesManuallyResolved"; entries: ReadonlyArray<ResolvedFleetEntry> }
  | { type: "cancel" }
  | { type: "confirm" }

export const addToFleetReducer = (state: AddToFleetState, action: AddToFleetAction): AddToFleetState => {
  switch (action.type) {
    case `setValidFleetEntries`:
      return {
        ...state,
        validFleetEntries: action.entries,
        status: `validated`,
      }
    case `setResolvedAndUnresolvedFleetEntries`:
      return {
        ...state,
        resolvedFleetEntries: action.resolved,
        unresolvedFleetEntries: action.unresolved,
        vehicleSetId: action.vehicleSetId,
        status: `serverResolved`,
      }
    case `entriesManuallyResolved`:
      return {
        ...state,
        resolvedFleetEntries: [...state.resolvedFleetEntries, ...action.entries],
        manuallyResolvedFleetEntries: action.entries,
        unresolvedFleetEntries: [],
      }
    case `confirm`:
      return {
        ...state,
        status: `confirmed`,
      }
    case `cancel`: {
      return {
        ...addToFleetInitialState,
        validFleetEntries: state.validFleetEntries,
      }
    }
    default:
      return state
  }
}
